export const heroData = {
  title: "Contact Us",
  subtitle: "For booking inquiries and questions about Yokohama Helicopter Cruise, please use the form below. Our dedicated staff will respond within 2 business days.",
  image:
    "https://readdy.ai/api/search-image?query=Elegant%20modern%20reception%20desk%20with%20warm%20ambient%20lighting%2C%20luxury%20concierge%20service%20atmosphere%2C%20dark%20navy%20and%20gold%20interior%20design%2C%20professional%20hospitality%20setting%2C%20editorial%20photography%2C%20no%20text&width=1920&height=600&seq=contacthero01&orientation=landscape",
};

export const formFields = {
  name: { label: "Your Name", placeholder: "e.g. John Smith", required: true },
  email: { label: "Email Address", placeholder: "e.g. example@email.com", required: true },
  phone: { label: "Phone Number", placeholder: "e.g. 090-1234-5678", required: false },
  inquiryType: {
    label: "Inquiry Type",
    options: [
      { value: "reservation", label: "Booking Inquiry" },
      { value: "pricing", label: "Pricing & Plans" },
      { value: "gift", label: "Gift Tickets" },
      { value: "first-time", label: "First-Time Questions" },
      { value: "cancel", label: "Cancellations & Changes" },
      { value: "other", label: "Other" },
    ],
    required: true,
  },
  preferredDate: { label: "Preferred Date (optional)", placeholder: "e.g. June 15, 2025", required: false },
  message: { label: "Message", placeholder: "Please feel free to write your questions or requests here", required: true },
};

export const notesData = {
  label: "NOTE",
  title: "Before You Contact Us",
  items: [
    "Please double-check your email address. If you do not receive a reply, please check your spam folder.",
    "If you prefer a phone response, please include your phone number.",
    "During busy periods, replies may take longer than usual. We appreciate your patience.",
    "For cancellations or changes, please contact us as early as possible.",
  ],
};

export const finalCTA = {
  title: "Feel free to reach\nout anytime",
  subtitle: "Our dedicated staff will carefully listen to your needs",
  ctas: [
    { label: "View Pricing & Plans", href: "/pricing", type: "primary" },
    { label: "First-Time Visitors", href: "/first-time", type: "secondary" },
  ],
};
